import { render, staticRenderFns } from "./data-display.vue?vue&type=template&id=4f0e6a99&scoped=true"
import script from "./data-display.vue?vue&type=script&lang=js"
export * from "./data-display.vue?vue&type=script&lang=js"
import style0 from "./data-display.vue?vue&type=style&index=0&id=4f0e6a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e6a99",
  null
  
)

export default component.exports